// extracted by mini-css-extract-plugin
export default {"zoomControlContainer":"W42rhmZoTGGnltjyMd0C","pageNumberContainer":"J2Ve6_wXzJ4m2uk39OvB"};